import React from "react";
import { Card, Row, Typography,  Col, Divider, Grid} from "antd";
import {  ArrowLeftOutlined } from "@ant-design/icons";
import moment from 'moment';

const { Title } = Typography;
const { useBreakpoint } = Grid;


export default function RatingDetail({order,setShowDetails, type}) {

        const screens = useBreakpoint();


    const getTime = (data, field) => {
        const filterSec = data?.filter((item)=> item.current_status === field);
        if(filterSec?.[0]){
            return  moment(filterSec?.[0]?.created_at).format('hh:mm A');
        }
        return '';
    };
    const getMenuNames = (data) => {
        const menus = data?.menu_items?.map((item)=> item.menu_item_name);
        return menus?.join(',');
    }
    return (
        <div>
             <div className="catering-header">
        <Title level={4} style={{cursor:"pointer"}}
        onClick={()=>setShowDetails(false)}> <ArrowLeftOutlined/> Order No - {order?.order?.order_num}</Title>
      </div>

      <div style={{ marginTop: 40 }}>
        <Card bordered={false} className="card-order-container">
         <div className={`${screens.md ? 'cat-each-section' : "flex-column cat-each-section"} `}>
            <div className="cat-section-title">ORDER DETAILS</div>
            <Row className="row-cat-section" gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <div className="cat-details-name">
                        <div className="cat-title">Server:</div>
                        <div className="cat-name">{order?.delivery_employee?.name}</div>
                    </div>
                    <div className="cat-details-name">
                        <div className="cat-title">Order Id:</div>
                        <div className="cat-name">{order?.order_id}</div>
                    </div>
                </Col>
                <Col xs={24} md={12}>
                <div className="cat-details-name">
                        <div className="cat-title">Time Allotted:</div>
                        <div className="cat-name">{getTime(order?.order_statuses, 'ORDER_PLACED')} - {getTime(order?.order_statuses, 'FULFILLED')} </div>
                    </div>
                    <div className="cat-details-name">
                        <div className="cat-title">Payment Status:</div>
                        <div className="cat-name">{order?.payment_providers?.name}</div>
                    </div>
                </Col>
                
            </Row>
         </div>
    
         <Divider/>
            <div className={`${screens.md ? 'cat-each-section' : "flex-column cat-each-section"} `}>
                    <div className="cat-section-title">Customer Details</div>
                    <Row className="row-cat-section" gutter={[16, 16]}>
                        <Col xs={24} md={12}>
                            <div className="cat-details-name">
                                <div className="cat-title">Name:</div>
                                <div className="cat-name">{order?.customer?.name}</div>
                            </div>
                            <div className="cat-details-name">
                                <div className="cat-title">Email:</div>
                                <div className="cat-name">{order?.customer?.email}</div>
                            </div>
                        </Col>
                        <Col xs={24} md={12}>
                            <div className="cat-details-name">
                                <div className="cat-title">Phone number:</div>
                                <div className="cat-name">{order?.customer?.phone_number}</div>
                            </div>
                        </Col>
                        
                    </Row>
            </div>
        <Divider/>
         <div className={`${screens.md ? 'cat-each-section' : "flex-column cat-each-section"} `}>
            <div className="cat-section-title">Items</div>
                <div style={{width:"100%"}}>
                    {order?.order_items?.map(item=>
                        <div className="row-cat-section" style={{justifyContent:"space-between",marginBottom:"20px",display:"flex"}}>
                            <div style={{display:"flex"}}>
                                <div style={{minWidth:"45px"}}>{item?.quantity} X </div> 
                                <div className="cat-details-desc">
                                    <div style={{marginLeft:"10px",fontWeight:600}}>{item?.name}</div>
                                    <div style={{marginLeft:"10px",opacity: 0.5, marginTop:"5px"}}>{item?.description}</div>
                                </div>
                            </div>
                            
                            <div style={{marginRight:"50px",fontWeight:600}}>
                                ${item?.price}
                            </div>
                        </div>
                    )}
                </div>
         </div>
         <Divider/>

         <div className={`${screens.md ? 'cat-each-section' : "flex-column cat-each-section"} `}>
            <div className="cat-section-title">ISSUE DETAILS</div>
            <Row className="row-cat-section" gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <div className="cat-details-name">
                    <div className="cat-title">Item:</div>
                    <div className="cat-name">{getMenuNames(order)}</div>
                    </div>
                    <div className="cat-details-name">
                    <div className="cat-title">Note:</div>
                    <div className="cat-name">{order?.order_issues?.description}</div>
                    </div>
                </Col>
                <Col xs={24} md={12}>
                    <div className="cat-details-name">
                    <div className="cat-title">Manager:</div>
                    <div className="cat-name">{order?.manager_info?.name}</div>
                    </div>
                    <div className="cat-details-name">
                    <div className="cat-title">Issue:</div>
                    <div className="cat-name">{order?.order_issues?.issue}</div>
                    </div>
                </Col>
                
            </Row>
         </div>
    
         <Divider/>
         <div className="cat-each-section">
            <div className="cat-section-title">Solution</div>
            <Row className="row-cat-section">
                <Col>
                    <div className="cat-details-name">
                    <div className="cat-name">{order?.order_issues?.solution}</div>
                    </div>
                </Col>
            </Row>
         </div>
        </Card>
        </div>
        </div>
       
    );
  }





